import React, { useEffect } from 'react';
import { ModalDialog } from 'e100-react-components';
import { MODALS, useApplicationOperations } from 'entities/application';
import { ConfirmActivationStep } from './ConfirmActivationStep/ConfirmActivationStep';
import { useSubscriptionConsentContext } from '../../context/subscriptionConsent';
import { useIntl } from 'react-intl';
import { Title } from './Title';
import { useSendEmail } from '../../hooks/useSendEmail';
import { useBoolState } from 'common/hooks';
import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

export const SubscribeModal = () => {
  const [isLoading, toggleLoading] = useBoolState();
  const { deleteActiveModal, addActiveModal } = useApplicationOperations();
  const { consent, email } = useSubscriptionConsentContext();

  const { formatMessage } = useIntl();

  const sendEmailSubscriptionRequest = useSendEmail();

  const applySubscription = async () => {
    try {
      toggleLoading();
      await sendEmailSubscriptionRequest();

      deleteActiveModal(MODALS.subscribe);
      addActiveModal(MODALS.successSubscribe);
    } catch (error) {
    } finally {
      toggleLoading();
    }
  };

  useEffect(() => {
    return () => {
      logAmplitudeEvent('closeSubscribeDialog');
    };
  }, []);


  return (
    <ModalDialog
      open
      maxWidth="md"
      isLoading={isLoading}
      title={<Title step={2} title={formatMessage({ id: 'confirmActivation' })} />}
      labelCancel={''}
      labelOk={formatMessage({ id: 'confirm' })}
      isValid={consent.legal && consent.marketing && !!email}
      onOk={applySubscription}
      showCloseButton
      onClose={() => {
        deleteActiveModal(MODALS.subscribe);
      }}
    >
      <ConfirmActivationStep />
    </ModalDialog>
  );
};
